import Layout from '@/layout'

const SeaImportRouter = {
  path: '/SeaImport',
  component: Layout,
  redirect: 'noredirect',
  name: 'SeaImport',
  meta: {
    title: 'seaImport',
    icon: 'daohang-ziliaoguanli',
    // roles: ['subsystem_SEAEXPORT']
    roles: []
  },
  children: [
    {
      path: 'Booking',
      component: () => import('@/views/cargo/v0/SeaImport/bookingNew'),
      name: 'SiBooking',
      meta: { title: 'seaImportBooking' },
      roles: []
    },
    {
      path: 'Prediction',
      component: () => import('@/views/cargo/v0/SeaImport/prediction'),
      name: 'SiPrediction',
      meta: { title: 'seaImportPrediction' },
      roles: ['module_SIPREALERT']
    },
    {
      path: 'ImportCharge',
      component: () => import('@/views/cargo/v0/SeaImport/ImportCharge/index'),
      name: 'ImportCharge',
      meta: { title: '批量导入费用(海进)' },
      roles: ['module_fmImportChargeSI']
    },
    {
      path: 'WarehouseModule',
      component: () => import('@/views/cargo/v0/SeaImport/WarehouseModule/index'),
      name: 'WarehouseModule',
      meta: { title: '仓库操作' },
      roles: ['module_SeaImportWarehouse']
    },
    {
      path: 'SeaEdiModule',
      component: () => import('@/views/cargo/v0/SeaImport/SeaEdiModule/index'),
      name: 'SeaEdiModule',
      meta: { title: '海运进口EDI' },
      roles: ['module_SeaEDIModule']
    }
  ]
}

export default SeaImportRouter
